import { useSelector } from 'react-redux';

import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import { isUserOperator } from 'app/admin/common/util/CommonUtil';
import OptimizationPipelineTableService from '../service/OptimizationPipelineTableService';
import ShowOptimizationPipelineButton from '../component/ShowOptimizationPipelineButton';

function OptimizationPipelineTable() {
	const user = useSelector(({ auth }) => auth.user);
	const isOperator = isUserOperator(user);

	const config = {
		key: 'optimizationPipeline',
		topic: 'optimizationPipeline',
		service: OptimizationPipelineTableService,
		editFormState: item => `/optimization-pipeline/edit/${item ? item.id : 'new'}`,
		toolbarAction: ['search', 'refresh', 'new'],
		rowAction: isOperator ? [] : ['modify', 'delete'],
		rowButtonList: [{ key: 'show', component: ShowOptimizationPipelineButton }],
		columns: [
			{
				key: 'name'
			}
		]
	};

	return <TableBrowser config={config} />;
}

export default withReducer('optimizationPipeline', reducer('optimizationPipeline'))(OptimizationPipelineTable);